let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jK7IB")).then(() => parcelRequire('75ppW'));